/**
 * AcceptRejectAll - Accept/reject all suggestions buttons
 */
import { uiLogger } from '@annote/core/utils/debug';
import { useSuggestedContext } from 'src/context/SuggestedContext';
import { useAIContext } from 'src/context/AIContextBackend';
import styled from 'styled-components';
import { colors, text } from '@annote/core/styles';

const Wrapper = styled.div<{ isShown: boolean }>`
  display: ${(props) => (props.isShown ? 'flex' : 'none')};
  position: absolute;
  top: -20px;
  right: 30px;
`;

const Button = styled.button<{ kind: 'accept' | 'reject' }>`
  background-color: ${(props) => colors.button[props.kind].primary};
  border: none;
  margin-right: 2px;
  border-radius: 4px;
  padding: 6px;
  box-shadow: ${colors.shadow.button};
  font-weight: ${text.weight.medium};

  &:hover {
    background-color: ${(props) => colors.button[props.kind].hover};
    box-shadow: ${colors.shadow.active};
  }
`;

export const AcceptRejectAll: React.FC = () => {
  const { acceptAllSuggestions, rejectAllSuggestions, hasSuggestions } = useSuggestedContext();
  const { clearMessages } = useAIContext();

  const handleAcceptAll = async (): Promise<void> => {
    console.log('[AcceptRejectAll] Keep All clicked, hasSuggestions:', hasSuggestions());
    try {
      await acceptAllSuggestions();
      clearMessages();
    } catch (error) {
      uiLogger.error('Failed to accept all suggestions:', error);
      // TODO: Show user-friendly error message
    }
  };

  const handleRejectAll = async (): Promise<void> => {
    try {
      // Explicit rejection from the reject button
      await rejectAllSuggestions('group_reject_all');
      clearMessages();
    } catch (error) {
      uiLogger.error('Failed to reject all suggestions:', error);
      // TODO: Show user-friendly error message
    }
  };

  return (
    <Wrapper isShown={hasSuggestions()}>
      <Button kind="accept" onClick={handleAcceptAll}>
        Keep All
      </Button>
      <Button kind="reject" onClick={handleRejectAll}>
        Undo All
      </Button>
    </Wrapper>
  );
};
